var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title wow fadeInUp"},[_vm._v("\n      "+_vm._s(_vm.$t("about").brand.text0)+"\n    ")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allBrand wow fadeInUp"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../asset/aike/about1111.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }